import i18n, { FormatFunction } from 'i18next';
import { initReactI18next } from 'react-i18next';

import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import { version } from '../../package.json';

export interface MultipleKeyParams {
  value: string;
  format: string;
}

const lowerCase = (key: string, format: string | FormatFunction | undefined) => {
  if (!key || typeof format !== 'string' || format !== 'lowercase') {
    return key;
  }
  const translatedStr = i18n.t(key);
  return translatedStr ? translatedStr.toLocaleLowerCase() : key;
};

const trimTrailingSpaces = (key: string) => {
  return key.trimEnd();
};

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(XHR)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    debug: false, // should be false in prod
    nsSeparator: false,
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'b', 'em', 'i'], // tags to keep when parsing
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      alwaysFormat: true,
      format: (key, format, lng, options) => {
        const formatType = format ? format : options?.format;
        if (options?.[`${key}Format`]) {
          return i18n.t(key, `${key}Format`);
        } else if (formatType === 'lowercase') {
          return lowerCase(key, formatType);
        } else if (formatType === 'trimTrailingSpaces') {
          return trimTrailingSpaces(key);
        }
        return key;
      },
    },
    preload: ['en', 'es'],
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      addPath: '/locales/add/{{lng}}/{{ns}}',
      queryStringParams: { v: version },
    },
  });

export default i18n;
